import { z } from "zod";
import { paginationSchema } from "./common.js";
export const tipoUtenzaSchema = z.enum(["DOMESTICA", "NON_DOMESTICA"]);
export const utenzaSchema = z.object({
    id: z.string().uuid(),
    codice_tari: z.string().max(32),
    tipo: tipoUtenzaSchema,
    intestatario_nominativo: z.string().max(240),
    intestatario_cf_piva: z.string().max(16).nullable(),
    indirizzo_via: z.string().max(240),
    indirizzo_civico: z.string().max(16),
    indirizzo_cap: z.string().max(8),
    geo_punto: z
        .object({ lat: z.number(), lng: z.number() })
        .nullable()
        .optional(),
    zona_id: z.string().uuid().nullable(),
    attiva: z.boolean(),
    data_attivazione: z.string().nullable().optional(),
    data_cessazione: z.string().nullable().optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const createUtenzaSchema = utenzaSchema
    .omit({ id: true, created_at: true, updated_at: true })
    .extend({
    zona_id: z.string().uuid().nullable().optional(),
    intestatario_cf_piva: z
        .string()
        .max(16)
        .nullable()
        .optional()
        .transform((v) => (v === "" ? null : v ?? null)),
});
export const updateUtenzaSchema = createUtenzaSchema.partial();
export const utenzaFiltersSchema = paginationSchema.extend({
    zona_id: z.string().uuid().optional(),
    tipo: tipoUtenzaSchema.optional(),
    attiva: z
        .string()
        .transform((v) => v === "true")
        .optional(),
    con_kit: z
        .string()
        .transform((v) => v === "true")
        .optional(),
    q: z.string().max(200).optional(),
});
export const utenzaListResponseSchema = z.object({
    items: z.array(utenzaSchema),
    next_cursor: z.string().nullable(),
    total: z.number().optional(),
});
//# sourceMappingURL=utenze.js.map